import Konva from "konva";
import { useRef } from "react";
import { Html } from "react-konva-utils";

/**
 * This is a component that allows you to edit the text of a text element in the canvas.
 */
interface TextFieldCanvasEditorProps {
    /** The function to call when the text field is blurred. */
    onBlur: () => void;
    /** The text element to edit. */
    element: Konva.Text;
    /** The function to call when the text changes. */
    onChange: (text: string) => void;
}

/**
 * This is a component that allows you to edit the text of a text element in the canvas.
 */
export const TextFieldCanvasEditor = ({
    onBlur,
    element,
    onChange,
}: TextFieldCanvasEditorProps) => {
    const ref = useRef<HTMLTextAreaElement>(null);

    return (
        <Html
            divProps={{
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    zIndex: 1000,
                },
            }}
        >
            <textarea
                ref={ref}
                onBlur={onBlur}
                defaultValue={element.text()}
                onChange={(e) => onChange(e.target.value)}
                style={{
                    position: "absolute",
                    top: `${element.y()}px`,
                    left: `${element.x()}px`,
                    width: `${element.width() + 60}px`,
                    height: `${(element.textArr.length + 1) * element.fontSize()}px`,
                    fontSize: `${element.fontSize()}px`,
                    border: "none",
                    outline: "none",
                    background: "none",
                    resize: "none",
                    lineHeight: `${element.fontSize()}px`,
                    fontFamily: element.fontFamily(),
                    transformOrigin: "left top",
                    textAlign: element.align() as unknown as undefined,
                    color: element.fill() as string,
                    padding: "0px",
                    margin: "0px",
                    overflow: "hidden",
                    zIndex: 1000,
                    transform: `rotate(${element.rotation()}deg)`,
                    fontWeight: element.fontVariant(),
                    fontStyle: element.fontStyle(),
                }}
                autoFocus
            />
        </Html>
    );
};
